import { z } from 'zod';

export const evidenceTypeValues = [
  'source_excel',
  'source_docx',
  'scale_slip',
  'photo',
  'receipt',
  'transfer_slip',
  'shipment_document',
  'approval_pdf',
  'generated_report',
  'other',
] as const;
export type EvidenceType = (typeof evidenceTypeValues)[number];

export const targetRecordTypeValues = [
  'inbound_lot',
  'inbound_line',
  'dismantling_session',
  'dismantling_output',
  'secondary_process_transfer',
  'shipment',
  'shipment_line',
  'material_inventory_movement',
  'monthly_inventory_snapshot',
  'monthly_batch',
] as const;
export type TargetRecordType = (typeof targetRecordTypeValues)[number];

export const evidenceFileSchema = z.object({
  evidence_file_id: z.string(),
  monthly_batch_id: z.string(),
  evidence_type: z.enum(evidenceTypeValues),
  original_file_name: z.string(),
  file_hash: z.string(),
  target_record_type: z.string().nullable().optional(),
  target_record_id: z.string().nullable().optional(),
  captured_at: z.string().nullable().optional(),
  uploaded_by: z.string(),
  uploaded_at: z.string(),
  immutable_flag: z.boolean(),
  company_file_id: z.string().nullable().optional(),
  file_source: z.enum(['legacy', 'local_upload', 'library_reuse']).optional(),
  created_at: z.string(),
  updated_at: z.string(),
});
export type EvidenceFileDto = z.infer<typeof evidenceFileSchema>;

export const linkRequestSchema = z.object({
  target_record_type: z.enum(targetRecordTypeValues),
  target_record_id: z.string().min(1),
});
export type LinkRequestInput = z.infer<typeof linkRequestSchema>;

export interface AttachEvidenceFromLibraryInput {
  batchId: string;
  companyFileId: string;
  evidenceType: EvidenceType;
}
